import {
  AppBar,
  Box,
  Breadcrumbs,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Icon,
  IconButton,
  Stack,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import React from "react";
import { styled } from "@mui/material/styles";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import { useState } from "react";
import { useEffect } from "react";
import CreatableSelect from "react-select/creatable";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& input": {
    padding: "10px 14px",
  },
}));

const codeUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.chartOfAccount}`;
const companyUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;

const ChartOfAccountsFrom = (props) => {
  const [Codes, setCodes] = useState([]);
  const [editData, setEditData] = useState([]);
  const [validError, setValidError] = useState({});
  // const [checksubmit, setCheckSubmit] = useState(false);
  const [saveDisable, setSaveDisable] = useState(true);
  const [companyList, setCompanyList] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState({});
  const [companyName, setCompanyName] = useState("");
  const [accountName, setAccountName] = useState("");
  const [dataType, setDataType] = useState([]);
  const [dataPath, setDataPath] = useState([]);
  const [groupCodeDisable, setGroupCodeDisable] = useState(false);
  const [companyDisable, setCompanyDisable] = useState(false);
  const [formLable, setFormLable] = useState("Not Compulsory");
  const [isDuplicate, setIsDuplicate] = useState(false)
  const [isCodeDuplicate, setIsCodeDuplicate] = useState(false)

  const {
    open,
    openRow,
    openEditRow,
    handleClose,
    onAdd,
    childRow,
    headRow,
    onEdit,
    editRow,
    onAddHeadRow,
    openViewRow,
    viewRow,
    AddCurrentRow,
    openCurrentRow,
    addAccountTypeRow,
    data,
    checkSubmit
  } = props;

  const [values, setValues] = useState({
    // accountName: "",
    accountCode: "",
    accountType: {},
    under: {},
    balanceType: { value: "Debit", label: "Debit" },
    costObject: { value: true, label: "Compulsory" },
    costCenter: { value: true, label: "Compulsory" },
    budget: { value: true, label: "Compulsory" },
    cashFlow: { value: true, label: "Compulsory" },
    assetAccount: { value: true, label: "Compulsory" },
    trialBalance: { value: true, label: "Compulsory" },
    profitLoss: { value: true, label: "Compulsory" },
    balanceSheet: { value: true, label: "Compulsory" },
    vat: { value: true, label: "Compulsory" },
    corporateTax: { value: true, label: "Compulsory" },
    consolidation: { value: true, label: "Compulsory" },
    currency: { value: "AED", label: "AED" },
  });
 
  const hasDuplicateInChildren = (node, value) => {
    if (node.name.toLowerCase() === value.toLowerCase() && (node?.id !== editRow?.data?.id || node?.id !== AddCurrentRow?.data?.id)) {
      return true;
    }

    if (node.children) {
      for (const child of node.children) {
        if (hasDuplicateInChildren(child, value)) {
          return true;
        }
      }
    }
    return false;
  };
  const hasDuplicateCodeInChildren = (node, value) => {
    if (node.code === value && (node?.id !== editRow?.data?.id || node?.id !== AddCurrentRow?.data?.id)) {
      return true;
    }

    if (node.children) {
      for (const child of node.children) {
        if (hasDuplicateCodeInChildren(child, value)) {
          return true;
        }
      }
    }
    return false;
  };

  const handleChange = (event) => {
    let numReg = new RegExp("^[0-9]*$");
    const inputVal = event.target.value?.split('').splice(0,10)?.join('');
    const value=parseInt(inputVal);
    console.log(":: inputValue", inputVal)
    if(inputVal === ""){
      setValues((prev) => ({ ...prev, [event.target.name]: inputVal }));
    } else {
      if(numReg.test(value) && event.target.value.trim()){
        setValues((prev) => ({ ...prev, [event.target.name]: value }));
      }
    }
    if(event.target.value !== 0 && numReg.test(value) && inputVal.trim()){
      const findDuplicate = data.some((item) => hasDuplicateCodeInChildren(item, inputVal))
      setIsCodeDuplicate(findDuplicate)
    }
  
  };
  function findByMatchingProperties(set, properties) {
    const filtered = set.filter(function (entry) {
            if(JSON.stringify(entry?.id) === JSON.stringify(properties?.id)){
                return true
            }else{
              if (entry.children && entry.children.length > 0) {
                for (const child of entry.children) {
                  if (findByMatchingProperties([child], properties)) {
                    return true;
                  }else{
                    return false;
                  }
                }
              }else{
                return false;
              }
            }

          });
          return filtered.length > 0 ? true : false
}

  const currentHierarchy = data.filter(row => {
    if(editRow){
      if(JSON.stringify(row?.id) === JSON.stringify(editRow?.data?.id) || (row?.children && row?.children.length > 0 && findByMatchingProperties(row?.children, editRow?.data))){
     return row;
      }
    }else if(AddCurrentRow){
      if(JSON.stringify(row?.id) === JSON.stringify(AddCurrentRow?.data?.id) || (row?.children && row?.children.length > 0 && findByMatchingProperties(row?.children, AddCurrentRow?.data))){
        return row;
         }
    }
  })

  const handleAccountNameChange = (event) => {
    setAccountName(event.target.value)
    if(event.target.value){
      const findDuplicate = currentHierarchy.some((item) => hasDuplicateInChildren(item, event.target.value))
      setIsDuplicate(findDuplicate)
    }
  };

  const handleSelect = (value, event) => {
    setValues((prev) => ({ ...prev, [event.name]: value }));
  };

  const handleCompanySelect = (event) => {
    const companyData = companyList.find((obj) => obj.id === event.value);
    setSelectedCompany({ value: companyData.id, label: companyData.id });
    setCompanyName(companyData.name);
  };

  const valueFromAccountType = (key) => {
    switch (key) {
      case "HEAD":
        return { value: "GROUP", label: "GROUP" };
      case "GROUP":
        return { value: "GENERAL_LEDGER", label: "General Ledger" };
      case "GENERAL_LEDGER":
        return { value: "LEDGER", label: "Ledger" };
      case "LEDGER":
        return { value: "SUB_LEDGER", label: "Sub Ledger" };
      case "SUB_LEDGER":
        return { value: "SUB_LEDGER", label: "Sub Ledger" };

      default:
        return { value: "GENERAL_LEDGER", label: "General Ledger" };
    }
  };

  const optionsAccountType = [
    { value: "HEAD", label: "HEAD" },
    { value: "GROUP", label: "GROUP" },
    { value: "GENERAL_LEDGER", label: "GENERAL LEDGER" },
    { value: "LEDGER", label: "LEDGER" },
    { value: "SUB_LEDGER", label: "SUB LEDGER" },
  ];
  const optionsBalanceType = [
    { value: "Debit", label: "Debit" },
    { value: "Credit", label: "Credit" },
    { value: "Debit/Credit", label: "Debit/Credit" },
  ];
  const options = [
    { value: true, label: "Compulsory" },
    { value: false, label: "Not Compulsory" },
  ];
  const optionsCurrency = [
    { value: "AED", label: "AED" },
    { value: "GBP", label: "GBP" },
    { value: "EUR", label: "EUR" },
  ];

  const loadCompanyData = async () => {
    try {
      const list = await OAuthService.getList(`${companyUrl}/search/findByCustomerTypes?customerTypes=FRANCHISE&customerTypes=NOLTEFZE&page=0&size=20&sort=`);
      const companies = list.data?._embedded?.companies;
      setCompanyList(companies);
    } catch (error) {
      console.log(error.message);
    }
  };

  const loadCode = async (parentId, accountType) => {
    if(accountType === 'LEDGER' || accountType === 'SUB_LEDGER'){
      try {
        const list = await OAuthService.getList(
          codeUrl + `/getCode?parentId=${parentId}&accountType=${accountType}`
        );
        const codeData = list.data;
        //const groupCode = valueFromAccountType(accountType).value;
        setValues((prev) => ({
          ...prev,
          accountCode: codeData, //groupCode !== "GROUP" ? codeData : "", 
        }));
        setGroupCodeDisable(true);
        // if (groupCode !== "GROUP") {
        // } else {
        //   setGroupCodeDisable(false);
        // }
      } catch (error) {
        console.log(error.message);
      }
    } else {
      setValues((prev) => ({
        ...prev,
        accountCode: '', 
      }));
    }
    
  };

  const getLabel = (isPositive) => {
    return isPositive ? "Compulsory" : `Not Compulsory`;
  };

  useEffect(() => {
    if (openEditRow) {
      setSelectedCompany({
        value: editRow.node.data.companyCode,
        label: editRow.node.data.companyCode,
      });
      setCompanyName(editRow.node.data.companyName);
      setAccountName(editRow.node.data.name)
      setValues((prev) => ({
        ...prev,
        // accountName: editRow.node.data.name,
        accountCode: editRow.node.data.code,
        accountType: {
          value: editRow.node.data.accountType,
          label: editRow.node.data.accountType,
        },
        assetAccount: {
          value: editRow.node.data.assetAccount,
          label: getLabel(editRow.node.data.assetAccount),
        },
        balanceType: {
          value: editRow.node.data.balanceType,
          label: editRow.node.data.balanceType,
        },
        budget: {
          value: editRow.node.data.budget,
          label: getLabel(editRow.node.data.budget),
        },
        balanceSheet: {
          value: editRow.node.data.balanceSheet,
          label: getLabel(editRow.node.data.balanceSheet),
        },
        costObject: {
          value: editRow.node.data.costObject,
          label: getLabel(editRow.node.data.costObject),
        },
        costCenter: {
          value: editRow.node.data.costCenter,
          label: getLabel(editRow.node.data.costCenter),
        },
        cashFlow: {
          value: editRow.node.data.cashFlow,
          label: getLabel(editRow.node.data.cashFlow),
        },
        corporateTax: {
          value: editRow.node.data.corporateTax,
          label: getLabel(editRow.node.data.corporateTax),
        },
        consolidation: {
          value: editRow.node.data.consolidation,
          label: getLabel(editRow.node.data.consolidation),
        },
        currency: {
          value: editRow.node.data.currency,
          label: editRow.node.data.currency,
        },
        profitLoss: {
          value: editRow.node.data.profitAndLoss,
          label: getLabel(editRow.node.data.profitAndLoss),
        },
        trialBalance: {
          value: editRow.node.data.trialBalance,
          label: getLabel(editRow.node.data.trialBalance),
        },
        vat: {
          value: editRow.node.data.vat,
          label: getLabel(editRow.node.data.vat),
        },
      }));
      setDataType(editRow.node.data.dataType);
      setDataPath(editRow.node.data.dataPath);
    }
  }, [openEditRow]);

  useEffect(() => {
    if (openViewRow) {
      const findGroup = optionsAccountType.find(
        (item) => item.value === viewRow.node.data.shortForm
      );
      setSelectedCompany({
        value: viewRow.node.data.companyCode,
        label: viewRow.node.data.companyCode,
      });
      setCompanyName(viewRow.node.data.companyName);
      setAccountName(viewRow.node.data.name)
      setValues((prev) => ({
        ...prev,
        // accountName: viewRow.node.data.name,
        accountCode: viewRow.node.data.code,
        accountType: findGroup,
        assetAccount: {
          value: viewRow.node.data.assetAccount,
          label: getLabel(viewRow.node.data.assetAccount),
        },
        balanceType: {
          value: viewRow.node.data.balanceType,
          label: viewRow.node.data.balanceType,
        },
        budget: {
          value: viewRow.node.data.budget,
          label: getLabel(viewRow.node.data.budget),
        },
        balanceSheet: {
          value: viewRow.node.data.balanceSheet,
          label: getLabel(viewRow.node.data.balanceSheet),
        },
        costObject: {
          value: viewRow.node.data.costObject,
          label: getLabel(viewRow.node.data.costObject),
        },
        costCenter: {
          value: viewRow.node.data.costCenter,
          label: getLabel(viewRow.node.data.costCenter),
        },
        cashFlow: {
          value: viewRow.node.data.cashFlow,
          label: getLabel(viewRow.node.data.cashFlow),
        },
        corporateTax: {
          value: viewRow.node.data.corporateTax,
          label: getLabel(viewRow.node.data.corporateTax),
        },
        consolidation: {
          value: viewRow.node.data.consolidation,
          label: getLabel(viewRow.node.data.consolidation),
        },
        currency: {
          value: viewRow.node.data.currency,
          label: viewRow.node.data.currency,
        },
        profitLoss: {
          value: viewRow.node.data.profitAndLoss,
          label: getLabel(viewRow.node.data.profitAndLoss),
        },
        trialBalance: {
          value: viewRow.node.data.trialBalance,
          label: getLabel(viewRow.node.data.trialBalance),
        },
        vat: {
          value: viewRow.node.data.vat,
          label: getLabel(viewRow.node.data.vat),
        },
      }));
      setDataType(viewRow.node.data.dataType);
      setDataPath(viewRow.node.data.dataPath);
    }
  }, [openViewRow]);

  useEffect(() => {
    if (open) {
      const findGroup = optionsAccountType.find(
        (item) => item.value === childRow.node.data.shortForm
      );
      loadCode(childRow.node.data.id, valueFromAccountType(findGroup.value).value);
      setAccountName('')
      setValues((prev) => ({
        ...prev,
        // accountName: "",
        accountType: valueFromAccountType(findGroup.value),
      }));
      setDataType(childRow.node.data.dataType);
      setDataPath(childRow.node.data.dataPath);
      setSelectedCompany({
        value: childRow.node.data.companyCode,
        label: childRow.node.data.companyCode,
      });
      setCompanyName(childRow.node.data.companyName);
    }
  }, [open]);

  useEffect(() => {
    if (openRow) {
      const findGroup = optionsAccountType.find(
        (item) => item.value === headRow?.node?.data?.shortForm
      );
      loadCompanyData();
      setAccountName('')
      setValues((prev) => ({
        ...prev,
        // accountName: "",
        accountType: { value: "HEAD", label: "HEAD" },
        accountCode: "",
      }));
    }
  }, [openRow]);

  useEffect(() => {
    if (openCurrentRow) {
      const findGroup = optionsAccountType.find(
        (item) => item.value === AddCurrentRow.node.data.shortForm
      );
      if (AddCurrentRow.node.data.shortForm !== "HEAD") {
        setCompanyDisable(true);
        setSelectedCompany({
          value: AddCurrentRow.node.data.companyCode,
          label: AddCurrentRow.node.data.companyCode,
        });
        setCompanyName(AddCurrentRow.node.data.companyName);
        setDataType(AddCurrentRow.node.parent?.data?.dataType);
        setDataPath(AddCurrentRow.node.parent?.data?.dataPath);
      } else {
        setCompanyDisable(false);
        loadCompanyData();
        setDataType([]);
        setDataPath([]);
      }
      setAccountName('')
      setValues((prev) => ({
        ...prev,
        // accountName: "",
        accountType: findGroup,
        accountCode: "",
      }));
      loadCode(AddCurrentRow.node.parent.id, AddCurrentRow.node.data.shortForm);
      
    }
  }, [openCurrentRow]);

  const {
    accountCode,
    // accountName,
    accountType,
    assetAccount,
    balanceSheet,
    balanceType,
    budget,
    cashFlow,
    company,
    consolidation,
    corporateTax,
    costObject,
    costCenter,
    currency,
    profitLoss,
    trialBalance,
    under,
    vat,
  } = values;

  useEffect(() => {
    if (accountName && companyName && accountCode && accountCode !== 0  && !isDuplicate && !isCodeDuplicate) {
      if (childRow) {
        if (childRow?.accountName !== accountName && childRow?.accountCode !== accountCode && !isDuplicate && !isCodeDuplicate) {
          setSaveDisable(false);
        } else {
          setSaveDisable(true);
        }
      } else {
        setSaveDisable(false);
      }
    } else {
      setSaveDisable(true);
    }
  }, [accountName, accountCode ,isCodeDuplicate, isDuplicate, companyName]);
  
  return (
    <>
      <Dialog
        open={open || openRow || openEditRow || openViewRow || openCurrentRow}
        fullWidth
        maxWidth="md"
        component="form"
      >
        <AppBar position="static">
          <Toolbar className="flex w-full justify-between">
            <Typography variant="subtitle1" color="inherit">
               {openEditRow ? "Update" : openViewRow ? "View" : "Add"} Chart Of Account
            </Typography>
            <IconButton
              onClick={() => {
                handleClose();
                setGroupCodeDisable(false);
                setIsDuplicate(false);
              }}
            >
              <Icon>close</Icon>
            </IconButton>
          </Toolbar>
        </AppBar>
        <form>
          <DialogContent classes={{ root: "p-16 pb-0 sm:p-24 sm:pb-0" }}>
            {!openRow && (
              <>
                <Breadcrumbs
                  aria-label="breadcrumb"
                  sx={{ mr: 1, mb: 2, flexGrow: 1, justifyContent: "end" }}
                  separator={<NavigateNextIcon fontSize="small" />}
                >
                  {dataPath?.map((name, index) => (
                    <Typography sx={{ lineHeight: 1.4 }}>
                      {name.replace(/_/g, " ")}
                      <br />
                      <small>{dataType[index]}</small>
                    </Typography>
                  ))}
                </Breadcrumbs>
                <hr className="mb-16" />
              </>
            )}
            <Grid container>
              <Grid xs={10} item>
                <Grid container className="pb-16">
                  <Grid
                    xs={2}
                    style={{ marginRight: "10px" }}
                    item
                    className="flex items-center"
                  >
                    <label>Company *</label>
                  </Grid>
                  <Grid xs={9} container>
                    <Grid xs={5} item>
                      <Stack className="mr-16">
                        <Select
                          value={selectedCompany}
                          onChange={handleCompanySelect}
                          className="select"
                          options={companyList?.map((d) => ({
                            value: d.id,
                            label: `${d.id} (${d.name})`,
                          }))}
                          styles={customStyles()}
                          isDisabled={
                            openViewRow || open || openEditRow || companyDisable
                          }
                        />
                      </Stack>
                    </Grid>
                    <Grid xs={6} item>
                      <Stack>
                        <StyledTextField
                          type="text"
                          name="companyName"
                          variant="outlined"
                          fullWidth
                          value={companyName}
                          disabled
                        />
                      </Stack>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid xs={8} item>
                <Grid container className="pb-16">
                  <Grid
                    xs={3}
                    style={{ maxWidth: "23%" }}
                    item
                    className="flex items-center"
                  >
                    <label>Account Name *</label>
                  </Grid>
                  <Grid xs={6} item>
                    <Stack className="mr-16">
                      <StyledTextField
                        type="text"
                        name="accountName"
                        variant="outlined"
                        fullWidth
                        value={accountName}
                        disabled={openViewRow}
                        onChange={handleAccountNameChange}
                        error={
                          (checkSubmit && !accountName) ||
                          validError.accountName
                            ? true
                            : false
                        }
                        helperText={
                          checkSubmit && !accountName
                            ? "This field is required"
                            : validError.accountName
                        }
                      />
                    </Stack>
                    {isDuplicate && <p style={{ color: '#f44336', fontSize: '1.2rem' }}>This name is already in use</p>}
                  </Grid>
                  <Grid xs={3} item>
                    <Stack>
                      <StyledTextField
                        type={(openViewRow || openEditRow || groupCodeDisable) ? 'text' : 'number'}
                        name="accountCode"
                        variant="outlined"
                        fullWidth
                        value={accountCode}
                        disabled={
                          openViewRow || openEditRow || groupCodeDisable
                        }
                        onChange={handleChange}
                        error={
                          (checkSubmit && !accountCode) ||
                          validError.accountCode ||
                          (props.processedData
                            .map((d) => d.code)
                            .filter((code) => code)
                            .includes(accountCode) &&
                            !openEditRow &&
                            !openViewRow)
                            ? true
                            : false
                        }
                        // helperText={
                        //   (checkSubmit && !accountCode)
                        //     ? "This field is required"
                        //     : (props.processedData
                        //         .map((d) => d.code)
                        //         .filter((code) => code)
                        //         .includes(accountCode) && !openEditRow && !openViewRow)
                        //     ? "This code is already in use"
                        //     : validError.accountCode
                        // }
                      />
                       {(accountCode !== 0 && isCodeDuplicate) && <p style={{ color: '#f44336', fontSize: '1.2rem' }}>This code is already in use</p>}
                    </Stack>
                  </Grid>
                </Grid>
                <Grid container className="pb-16">
                  <Grid
                    xs={3}
                    style={{ maxWidth: "23%" }}
                    item
                    className="flex items-center"
                  >
                    <label>Account Type *</label>
                  </Grid>
                  <Grid xs={6} item>
                    <Stack className="mr-16">
                      <Select
                        name="accountType"
                        options={optionsAccountType}
                        styles={customStyles()}
                        value={accountType}
                        isDisabled
                        onChange={handleSelect}
                        error={
                          (checkSubmit && !accountType) ||
                          validError.accountType
                            ? true
                            : false
                        }
                        helperText={
                          checkSubmit && !accountType
                            ? "This field is required"
                            : validError.accountType
                        }
                      />
                    </Stack>
                  </Grid>
                  {/* <Grid xs={3} item>
                    <Stack>
                      <Select
                        name="under"
                        options={optionsUnder}
                        styles={customStyles()}
                        value={under}
                        onChange={handleSelect}
                        isDisabled={openViewRow}
                        error={
                          (checkSubmit && !under) || validError.under
                            ? true
                            : false
                        }
                        helperText={
                          checkSubmit && !under
                            ? "This field is required"
                            : validError.under
                        }
                      />
                    </Stack>
                  </Grid> */}
                </Grid>
              </Grid>
              {/* <Grid xs={4} item>
                <Box className="text-right">
                  <Typography>Date:</Typography>
                  <Typography>
                    Created By/At: <span>Arun</span> 14 May 2023
                  </Typography>
                  <Typography>
                    Changed By/At: <span>Arun</span> 14 May 2023
                  </Typography>
                </Box>
              </Grid> */}
            </Grid>

            <hr className="mb-16" />
            <Grid container>
              <Grid xs={5.5} item>
                <Grid container className="pb-16">
                  <Grid xs={4} item className="flex items-center">
                    <label>Balance Type</label>
                  </Grid>
                  <Grid xs={8} item>
                    <Stack>
                      <Select
                        options={optionsBalanceType}
                        styles={customStyles()}
                        value={balanceType}
                        name="balanceType"
                        onChange={handleSelect}
                        isDisabled={openViewRow}
                        error={
                          (checkSubmit && !balanceType) ||
                          validError.balanceType
                            ? true
                            : false
                        }
                        helperText={
                          checkSubmit && !balanceType
                            ? "This field is required"
                            : validError.balanceType
                        }
                        formatOptionLabel={(option, { context }) => {
                          return option.label;
                        }}
                      />
                    </Stack>
                  </Grid>
                </Grid>
                <Grid container className="pb-16">
                  <Grid xs={4} item className="flex items-center">
                    <label>Cost Center</label>
                  </Grid>
                  <Grid xs={8} item>
                    <Stack>
                      <Select
                        options={options}
                        styles={customStyles()}
                        name="costCenter"
                        value={costCenter}
                        onChange={handleSelect}
                        isDisabled={openViewRow}
                        error={
                          (checkSubmit && !costCenter) || validError.costCenter
                            ? true
                            : false
                        }
                        helperText={
                          checkSubmit && !costCenter
                            ? "This field is required"
                            : validError.costCenter
                        }
                      />
                    </Stack>
                  </Grid>
                </Grid>
                <Grid container className="pb-16">
                  <Grid xs={4} item className="flex items-center">
                    <label>Cost Object</label>
                  </Grid>
                  <Grid xs={8} item>
                    <Stack>
                      <Select
                        options={options}
                        styles={customStyles()}
                        name="costObject"
                        value={costObject}
                        onChange={handleSelect}
                        isDisabled={openViewRow}
                        error={
                          (checkSubmit && !costObject) || validError.costObject
                            ? true
                            : false
                        }
                        helperText={
                          checkSubmit && !costObject
                            ? "This field is required"
                            : validError.costObject
                        }
                      />
                    </Stack>
                  </Grid>
                </Grid>
                <Grid container className="pb-16">
                  <Grid xs={4} item className="flex items-center">
                    <label>Budget</label>
                  </Grid>
                  <Grid xs={8} item>
                    <Stack>
                      <Select
                        options={options}
                        styles={customStyles()}
                        name="budget"
                        value={budget}
                        onChange={handleSelect}
                        isDisabled={openViewRow}
                        error={
                          (checkSubmit && !budget) || validError.budget
                            ? true
                            : false
                        }
                        helperText={
                          checkSubmit && !budget
                            ? "This field is required"
                            : validError.budget
                        }
                      />
                    </Stack>
                  </Grid>
                </Grid>
                <Grid container className="pb-16">
                  <Grid xs={4} item className="flex items-center">
                    <label>Cash Flow</label>
                  </Grid>
                  <Grid xs={8} item>
                    <Stack>
                      <Select
                        options={options}
                        styles={customStyles()}
                        name="cashFlow"
                        value={cashFlow}
                        onChange={handleSelect}
                        isDisabled={openViewRow}
                        error={
                          (checkSubmit && !cashFlow) || validError.cashFlow
                            ? true
                            : false
                        }
                        helperText={
                          checkSubmit && !cashFlow
                            ? "This field is required"
                            : validError.cashFlow
                        }
                      />
                    </Stack>
                  </Grid>
                </Grid>
                <Grid container className="pb-16">
                  <Grid xs={4} item className="flex items-center">
                    <label>Asset Account</label>
                  </Grid>
                  <Grid xs={8} item>
                    <Stack>
                      <Select
                        options={options}
                        styles={customStyles()}
                        name="assetAccount"
                        value={assetAccount}
                        onChange={handleSelect}
                        isDisabled={openViewRow}
                        error={
                          (checkSubmit && !assetAccount) ||
                          validError.assetAccount
                            ? true
                            : false
                        }
                        helperText={
                          checkSubmit && !assetAccount
                            ? "This field is required"
                            : validError.assetAccount
                        }
                      />
                    </Stack>
                  </Grid>
                </Grid>
                <Grid container className="pb-16">
                  <Grid xs={4} item className="flex items-center">
                    <label>Trial Balance</label>
                  </Grid>
                  <Grid xs={8} item>
                    <Stack>
                      <Select
                        options={options}
                        styles={customStyles()}
                        name="trialBalance"
                        value={trialBalance}
                        onChange={handleSelect}
                        isDisabled={openViewRow}
                        error={
                          (checkSubmit && !trialBalance) ||
                          validError.trialBalance
                            ? true
                            : false
                        }
                        helperText={
                          checkSubmit && !trialBalance
                            ? "This field is required"
                            : validError.trialBalance
                        }
                      />
                    </Stack>
                  </Grid>
                </Grid>
              </Grid>
              <Grid xs={1} item></Grid>
              <Grid xs={5.5} item>
                <Grid container className="pb-16">
                  <Grid xs={4} item className="flex items-center">
                    <label>Profit & Loss</label>
                  </Grid>
                  <Grid xs={8} item>
                    <Stack>
                      <Select
                        options={options}
                        styles={customStyles()}
                        name="profitLoss"
                        value={profitLoss}
                        onChange={handleSelect}
                        isDisabled={openViewRow}
                        error={
                          (checkSubmit && !profitLoss) || validError.profitLoss
                            ? true
                            : false
                        }
                        helperText={
                          checkSubmit && !profitLoss
                            ? "This field is required"
                            : validError.profitLoss
                        }
                      />
                    </Stack>
                  </Grid>
                </Grid>
                <Grid container className="pb-16">
                  <Grid xs={4} item className="flex items-center">
                    <label>Balance Sheet</label>
                  </Grid>
                  <Grid xs={8} item>
                    <Stack>
                      <Select
                        options={options}
                        styles={customStyles()}
                        name="balanceSheet"
                        value={balanceSheet}
                        onChange={handleSelect}
                        isDisabled={openViewRow}
                        error={
                          (checkSubmit && !balanceSheet) ||
                          validError.balanceSheet
                            ? true
                            : false
                        }
                        helperText={
                          checkSubmit && !balanceSheet
                            ? "This field is required"
                            : validError.balanceSheet
                        }
                      />
                    </Stack>
                  </Grid>
                </Grid>
                <Grid container className="pb-16">
                  <Grid xs={4} item className="flex items-center">
                    <label>VAT</label>
                  </Grid>
                  <Grid xs={8} item>
                    <Stack>
                      <Select
                        options={options}
                        styles={customStyles()}
                        name="vat"
                        value={vat}
                        onChange={handleSelect}
                        isDisabled={openViewRow}
                        error={
                          (checkSubmit && !vat) || validError.vat ? true : false
                        }
                        helperText={
                          checkSubmit && !vat
                            ? "This field is required"
                            : validError.vat
                        }
                      />
                    </Stack>
                  </Grid>
                </Grid>
                <Grid container className="pb-16">
                  <Grid xs={4} item className="flex items-center">
                    <label>Corporate Tax</label>
                  </Grid>
                  <Grid xs={8} item>
                    <Stack>
                      <Select
                        options={options}
                        styles={customStyles()}
                        name="corporateTax"
                        value={corporateTax}
                        onChange={handleSelect}
                        isDisabled={openViewRow}
                        error={
                          (checkSubmit && !corporateTax) ||
                          validError.corporateTax
                            ? true
                            : false
                        }
                        helperText={
                          checkSubmit && !corporateTax
                            ? "This field is required"
                            : validError.corporateTax
                        }
                      />
                    </Stack>
                  </Grid>
                </Grid>
                <Grid container className="pb-16">
                  <Grid xs={4} item className="flex items-center">
                    <label>Consolidation</label>
                  </Grid>
                  <Grid xs={8} item>
                    <Stack>
                      <Select
                        options={options}
                        styles={customStyles()}
                        name="consolidation"
                        value={consolidation}
                        onChange={handleSelect}
                        isDisabled={openViewRow}
                        error={
                          (checkSubmit && !consolidation) ||
                          validError.consolidation
                            ? true
                            : false
                        }
                        helperText={
                          checkSubmit && !consolidation
                            ? "This field is required"
                            : validError.consolidation
                        }
                      />
                    </Stack>
                  </Grid>
                </Grid>
                <Grid container className="pb-16">
                  <Grid xs={4} item className="flex items-center">
                    <label>Currency</label>
                  </Grid>
                  <Grid xs={8} item>
                    <Stack>
                      <Select
                        options={optionsCurrency}
                        styles={customStyles()}
                        name="currency"
                        value={currency}
                        onChange={handleSelect}
                        isDisabled={openViewRow}
                        error={
                          (checkSubmit && !currency) || validError.currency
                            ? true
                            : false
                        }
                        helperText={
                          checkSubmit && !currency
                            ? "This field is required"
                            : validError.currency
                        }
                      />
                    </Stack>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions
            sx={{ background: "#373c42" }}
            className="justify-between px-16 sm:px-16"
          >
            <Box>
              {/* <Typography className="font-medium text-3xl leading-none mb-4">
                <small>Opening Balance:</small> 54682.02
              </Typography> */}
            </Box>
            <Button
              variant="contained"
              color="primary"
              type="button"
              disabled={
                saveDisable ||
                isDuplicate ||
                (props.processedData
                  .map((d) => d.code)
                  .filter((code) => code)
                  .includes(accountCode) &&
                  !openEditRow)
              }
              onClick={() => {
                setGroupCodeDisable(false);
                if (open) {
                  
                  onAdd(childRow, values, selectedCompany, companyName, accountName);
                  //handleClose();
                } else if (openRow) {
                  onAddHeadRow(headRow, values, selectedCompany, companyName, accountName);

                  //handleClose();
                } else if (openEditRow) {
                  onEdit(editRow, values, accountName);
                  //handleClose();
                } else if (openCurrentRow) {
                  addAccountTypeRow(
                    AddCurrentRow,
                    values,
                    selectedCompany,
                    companyName,
                    accountName
                  );
                  //handleClose();
                }
                // else {
                //   handleClose();
                // }
                handleClose();
                setIsDuplicate(false);
              }}
            >
              {openViewRow ? "Close" : "Save & Exit"}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};

export default ChartOfAccountsFrom;
